﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global, isEmpty } from "../Common/saop-common";
import { SaopServicesCore } from "../Core/saop-services-core";
import * as moment from '../../node_modules/moment/moment';
import { SaopRegUraDogodekView } from "./saop-regUraDogodek-view";
import { SaopRegCurrentEventView } from './saop-regCurrentEvent-view'
import { SaopRegCurrentTimeHelper } from './saop-reg-current-time-helper'

export class SaopRegTodayEventsView extends SaopRegUraDogodekView {
    public regCurrentEventView:SaopRegCurrentEventView;
    //
    private _saopServicesCore :SaopServicesCore;
    private saldoUreTekoceHHMM_ms = 0;
    private _helper = new SaopRegCurrentTimeHelper();

    constructor(viewId:string,libName:string = "") {
        super(viewId,libName);
        this._saopServicesCore = new SaopServicesCore();
        //
        this.refreshData = this.refreshListData.bind(this);
        //
        this.regCurrentEventView = new SaopRegCurrentEventView("#regAcctionButtonsView",libName+".regCurrentEventView");
        this.regCurrentEventView.afterSubmitSuccess = this.refreshListData.bind(this);   
    }

    initView(): void {
        global.ConsoleLogDegug("initView");
        this.initClock();
        this.onReadyInitRegUraDogodekView();
        this.onReadyInitDogodkiDanasnjiPartialView();        
    }

    bindGridEvents(){
        global.ConsoleLogDegug("bindGridEvents");
        let _this = this;
        //
        $("#regUraDogodekAddRecord").off("click");
        $("#regUraDogodekAddRecord").on('click', function(row){
            global.ConsoleLogDegug("regUraDogodekAddRecord.click");
            let currentDate = moment(new Date()).format("DD.MM.YYYY")
            _this.addRecord({ SelectedDay:currentDate});
        });         
        //
        $(".regDogodkiDanasnjiTable_edit").off("click");
        $(".regDogodkiDanasnjiTable_edit").on('click', function(row){
            global.ConsoleLogDegug("regDogodkiDanasnjiTable_edit.click");
            let _btnEdit = row.currentTarget;
            let btnEnabled = _btnEdit.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let zacetek = _btnEdit.getAttribute("data-zacetek");
                let konec = _btnEdit.getAttribute("data-konec");
                _this.editRecord({ idStart: zacetek, idEnd: konec },_this);
            }            
        });        
        //
        $(".regDogodkiDanasnjiTable_delete").off("click");
        $(".regDogodkiDanasnjiTable_delete").on('click', function(row){
            global.ConsoleLogDegug("regDogodkiDanasnjiTable_delete.click");
            let _btnDelete = row.currentTarget;
            let btnEnabled = _btnDelete.getAttribute("data-enabled");
            if (btnEnabled.toString().toLowerCase() == "true") {
                let zacetek = _btnDelete.getAttribute("data-zacetek");
                let konec = _btnDelete.getAttribute("data-konec");
                // //
                let deleteModalFormTitle = _this.translationService.translate("Brisanje");
                let deleteModalFormBody = _this.translationService.translate("Ali ste prepričani, da želite izbrisati dogodek?");
                //
                _this.deleteRecord(deleteModalFormTitle,deleteModalFormBody,{ idStart: zacetek, idEnd: konec });
            }
        });         
    }

    afterRefreshData():void {
        global.ConsoleLogDegug("SaopRegTodayEventsView.afterRefreshListData");
    }

    refreshListData(trigger:boolean = true):void {
        global.ConsoleLogDegug("SaopRegTodayEventsView.refreshView");
        let _this = this;

        this._saopServicesCore.afterDone = function(response){
            $("#regTodayRecordForm").html(response);
            _this.bindGridEvents();
            _this.regCurrentEventView.bindFormAjaxEvents();   
        };
        this._saopServicesCore.ExecuteAction({
            action:"REGTodayEvents/MainFormPartial" 
            ,data:null
            ,type:"GET"
            ,spinnerDivId:"#regTodayRecordLoading"
        });       

        if (trigger && this.afterRefreshData != null){ this.afterRefreshData(); }
    }

    onReadyInitRegUraDogodekView(): void {
        global.ConsoleLogDegug("onReadyInitRegUraDogodekView");

        let message = <string>($("#OnLoadMessage").val());
        if (message) {
            alertify.message(message);
        }

        this.refreshListData();
    }

    initClock(): void {
        global.ConsoleLogDegug("onReadyInitDogodkiTekociPartialView");

        this.updateClock();
        this.updateClock1();
        this.updateClock2();
        this.updateClock3();

        setInterval(this.updateClock.bind(this), 1000)
        setInterval(this.updateClock1.bind(this), 1000)
        setInterval(this.updateClock2.bind(this), 1000)
        setInterval(this.updateClock3.bind(this), 1000)
    }

    updateClock(): void {
        let clockElement = $("#clock");

        // trenutni čas
        let currentTime = moment();
        let currentTime_ms = moment.duration(currentTime.format("HH:mm:ss")).asMilliseconds();

        // trenutni čas kot niz
        let currentTimeString = moment.utc(Math.abs(currentTime_ms)).format("HH:mm:ss");

        clockElement.html(currentTimeString);
    }

    convertHHmmssToNumber(ureHHMM:string):number{
        try{
            //NaN
            if (ureHHMM.toLowerCase().includes("nan")) {
                return 0;
            }
            let saldoUreHHMM_list = ureHHMM.split(":");
            let saldoUreHHMM_ms = (Math.abs(Number(saldoUreHHMM_list[0]) * 3600) + Math.abs(Number(saldoUreHHMM_list[1]) * 60)) * 1000;
            saldoUreHHMM_ms = saldoUreHHMM_list[0][0] == '-' ? saldoUreHHMM_ms * (-1) : saldoUreHHMM_ms;
            return saldoUreHHMM_ms;
        } catch (e) {

        }

        return 0;
    }

    updateClock1(): void {
        let clockElement1 = $("#clock1");

        //saldo vseh zaključenih dogodkov na dnevni ravni (stolpec "Dnevni saldo" v "Mesečni evidenci")
        let saldoUreHHMM_ms = this._helper.get_time("#SaldoUreHHMM");

        //trajnje zadnjega dogodka pred trenutnim časom
        let result_ms = saldoUreHHMM_ms + this._helper.get_current_event_passed_time("#UraZadnjegaDogodka");

        //ms -> formatted string
        const result = this._helper.format_time_string(result_ms);;

        clockElement1.html(result);
    }

    updateClock2(): void {
        let clockElement2 = $("#clock2");

        //saldo vseh zaključenih dogodkov na dnevni ravni (stolpec "Tekoči saldo" v "Mesečni evidenci")
        let saldoUreTekoceHHMM_ms = this._helper.get_time("#SaldoUreTekoceHHMM");

        //trajnje zadnjega dogodka pred trenutnim časom
        let result_ms = saldoUreTekoceHHMM_ms + this._helper.get_current_event_passed_time("#UraZadnjegaDogodka");

        //ms -> formatted string (ne moremo uporabit enake funkcije kot v clock1, ker tudkaj lahko pride do ur večjih od 24)
        const result = this._helper.format_time_string(result_ms);

        this.saldoUreTekoceHHMM_ms = this.convertHHmmssToNumber(result);

        clockElement2.html(result);
    }

    updateClock3(): void {
        let clockElement3 = $("#clock3");

        let naRazpolagoHHMM_ms = this._helper.get_time("#naRazpolagoHHMM");

        let result_ms = naRazpolagoHHMM_ms + this.saldoUreTekoceHHMM_ms;
      
        const result = this._helper.format_time_string(result_ms);

        clockElement3.html(result);
    }

    onReadyInitDogodkiDanasnjiPartialView(): void {
        global.ConsoleLogDegug("onReadyInitDogodkiDanasnjiPartialView");

        $("#regDogodkiDanasnjiTable tbody tr").each(
            function (i, row) {
                // koda zakomentirana, ker ni potrebna.
                // Če ni zakomentirana, se pojavijo težave pri refresh view "Dogodki na dan", in se polje "Konec" obarva rdece zaradi spodnje kode

                //var $actualRow = $(row);

                //if ($actualRow.children('td:nth-child(2)').text() == "") {
                //    $(this).children('td:nth-child(6)').css("background-color", '#FAC0BE');
                //} else if ($actualRow.children('td:nth-child(1)').text() == "") {
                //    $(this).children('td:nth-child(5)').css("background-color", '#FAC0BE');
                //}
            });

        $("#webgrid1 th:nth-child(1)").hide();
        $("#webgrid1 th:nth-child(2)").hide();
    }

}


